import React, { useEffect, useState } from 'react';
import style from './Profile.module.css';
import { ErrorMessage, Form, Formik, Field } from "formik";
import * as Yup from "yup";
import { authAxios } from '../../../API/apiRequest';
import { Loading } from "../../../components/Loading/Loading";
import { toast, ToastContainer } from "material-react-toastify";
import { login, logout } from "../../../State/Slice/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from 'react-bootstrap';

interface Profile {
    address: string,
    birthdate: string,
    email: string,
    gender: string,
    id: string,
    isSadat: boolean
    name: string,
    phone: string,
    picture: string,
}

function AccountData(props: any) {
    const dispatch = useDispatch();
    const state: any = useSelector(s => s);
    const [Load, setLoad] = useState<boolean>(true)
    const [Change, setChange] = useState<boolean>(false)
    const [profile, setprofile] = useState<Profile>()
    const [show, setShow] = useState<boolean>(false)
    useEffect(() => {
        setChange(props.changeimg)
    }, [props.changeimg])
    useEffect(() => {
        setLoad(true);
        authAxios.get(`/employee/profile`).then((res) => {
            if (res.status === 200) {
                setprofile(res.data);
                setLoad(false)
            }
        }).catch(err => {
            console.log(err)
        })
    }, [])

    function formatDate(date: string) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, month, day].join('-');
    }


    const onDeleteAccount = () => {
        authAxios.delete(`/employee/delete`).then(res => {
            if (res.status === 200) {
                localStorage.clear()
                dispatch(logout())
                window.location.href = "/login"
            }
        }).catch(err => {
            console.log(err)
        })
    }

    return (<>
        {Load ? (<div className={"d-flex justify-content-center"}><Loading /></div>) : (
            <>
                <Modal show={show} onHide={() => setShow(false)} centered>
                    <Modal.Header closeButton style={{
                        display: "flex",
                        flexDirection: "row-reverse", // Reverse the order of elements
                        alignItems: "center",
                    }}>
                        <Modal.Title style={{ marginRight: "0" }}>تأكيد الحذف</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='text-center'>
                        هل أنت متأكد من أنك تريد حذف حسابك؟
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShow(false)}>
                            لا
                        </Button>
                        <Button variant="danger" onClick={onDeleteAccount}>
                            نعم حذف الحساب
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer
                    closeOnClick={false}
                    autoClose={3000}
                    pauseOnHover
                    newestOnTop
                    hideProgressBar={false}

                    position="bottom-right" rtl />


                <div style={{ boxSizing: 'border-box' }} className={'container rtl mt-4 animate__animated animate__pulse  ' + style.component}>
                    <div>
                        <h2 className={'text-white my-2'}>المعلومات الشخصية</h2>
                    </div>

                    <Formik
                        initialValues={{
                            name: profile ? profile.name : "",
                            phone: profile ? profile.phone : "",
                            email: profile ? profile.email : "",
                            birthdate: profile ? profile.birthdate : "",
                            gender: profile ? profile.gender : "",
                            sadat: profile ? profile.isSadat ? "1" : "0" : "",
                            address: profile ? profile.address : ""
                        }}
                        validationSchema={Yup.object().shape({
                            name: Yup.string().min(4, 'برجاء ادخال الإسم كامل').max(40, 'برجاء ادخال الإسم بشكل صحيح').matches(/^\s*[\S]+(\s[\S]+)+\s*$/gms, 'برجاء ادخال الإسم كامل').required('برجاء ادخال الإسم كامل'),
                            phone: Yup.string().max(11, 'برجاء ادخل رقم هاتف صحيح').min(11, 'برجاء ادخل رقم هاتف صحيح').required('برجاء ادخل رقم هاتفك'),
                            email: Yup.string().email(' برجاء ادخل بريد الأكتروني صحيح').required('برجاء ادخل بريدك الأكتروني'),
                            birthdate: Yup.date().max(new Date(), 'برجاءادخل تاريخ ميلاد فعلي').required('برجاءادخل تاريخ ميلادك'),
                            gender: Yup.string().required('برجاء اختيار النوع'),
                            sadat: Yup.string().required('هل انت مقيم بمدينه السادات؟'),
                            address: Yup.string().min(4, 'برجاء ادخل عنوان صحيح').required('برجاء ادخل عنوانك')
                        })}

                        onSubmit={(Values: any) => {
                            let formData = new FormData()
                            formData.append("avatar", props.Img);
                            formData.append("name", Values.name);
                            formData.append("isSadat", Values.sadat);
                            formData.append("phone", Values.phone);
                            formData.append("email", Values.email);
                            formData.append("gender", Values.gender);
                            formData.append("address", Values.address);
                            formData.append("birthdate", Values.birthdate);
                            setLoad(true);
                            authAxios.post(`/employee/profile`, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }).then(async (res) => {
                                if (res.status === 200) {
                                    let user = { ...state.user };
                                    user.name = res.data.name;
                                    user.picture = res.data.picture;
                                    user.gender = res.data.gender;
                                    let jsonuser: any = localStorage.getItem('user');
                                    let newuser: any = { ...JSON.parse(jsonuser), ...user }
                                    dispatch(login(user))
                                    await localStorage.setItem('user', JSON.stringify(newuser))
                                    setprofile(res.data);
                                    setChange(false);
                                    props.setchangeimg();
                                    setLoad(false)
                                    setChange(false)
                                    toast.success("تم حفظ التعديلات");
                                }
                            }).catch(err => {
                                if (err.response.data) {
                                    toast.error(err.response.data.errors[0]);
                                    setLoad(false)
                                }
                            })
                        }}


                    >
                        {({
                            setFieldValue,
                            setFieldError,
                            values,
                            errors,
                            touched,
                        }) => (
                            <Form>

                                <div className={'row'}>
                                    <div className={'col-12 col-lg-6 py-2'} style={{ boxSizing: 'border-box' }}>
                                        <label htmlFor={'Name'} className={'text-white mb-2'}>الاسم</label>

                                        <Field
                                            id={"Name"}
                                            style={{ boxSizing: 'border-box' }}
                                            onChange={(e: any) => {
                                                setChange(true);

                                                setFieldValue("name", e.target.value);


                                            }}
                                            name="name"
                                            type="text"
                                            className={'form-control  ' + style.inputstyle + (errors.name && touched.name ? ' is-invalid' : '')}
                                            placeholder={`ادخل اسمك`}
                                        />
                                        <ErrorMessage name="name" className={style.TextError} component="div" />
                                    </div>
                                    <div className={'col-12 col-lg-6 py-2'} style={{ boxSizing: 'border-box' }}>
                                        <label htmlFor={'phone'} className={'text-white mb-2'}>الهاتف</label>

                                        <Field
                                            id={"phone"}
                                            name="phone"
                                            style={{ boxSizing: 'border-box' }}
                                            onChange={(e: any) => {
                                                setChange(true);
                                                setFieldValue("phone", e.target.value);
                                            }}
                                            type="text"
                                            className={'form-control  ' + style.inputstyle + (errors.phone && touched.phone ? ' is-invalid' : '')}
                                            placeholder={`ادخل رقم هاتفك`}
                                        />
                                        <ErrorMessage name="phone" className={style.TextError} component="div" />
                                    </div>
                                    <div className={'col-12 col-lg-6 py-2'} style={{ boxSizing: 'border-box' }}>
                                        <label htmlFor={'email'} className={'text-white mb-2'}>البريد
                                            الاكتروني</label>

                                        <Field
                                            id={"email"}
                                            name="email"
                                            style={{ boxSizing: 'border-box' }}
                                            onChange={(e: any) => {
                                                setChange(true);
                                                setFieldValue("email", e.target.value);
                                            }}
                                            type="email"
                                            className={'form-control  ' + style.inputstyle + (errors.email && touched.email ? ' is-invalid' : '')}
                                            placeholder={`ادخل بريدك الاكتروني`}
                                        />
                                        <ErrorMessage name="email" className={style.TextError} component="div" />
                                    </div>
                                    <div className={'col-12 col-lg-6 py-2'} style={{ boxSizing: 'border-box' }}>
                                        <label htmlFor={'birthdate'} className={'text-white mb-2'}>تاريخ
                                            الميلاد</label>

                                        <Field
                                            style={{ boxSizing: 'border-box' }}
                                            id={"birthdate"}
                                            name="birthdate"
                                            type="Date"
                                            onChange={(e: any) => {
                                                setChange(true);
                                                setFieldValue("birthdate", e.target.value);
                                            }}
                                            value={formatDate(values.birthdate)}
                                            className={'form-control  ' + style.inputstyle + (errors.phone && touched.phone ? ' is-invalid' : '')}
                                            placeholder={`ادخل تاريخ ميلادك`}
                                        />
                                        <ErrorMessage name="birthdate" className={style.TextError}
                                            component="div" />
                                    </div>

                                    <div className={'col-12   py-2'} style={{ boxSizing: 'border-box' }}>
                                        <label htmlFor={'address'} className={'text-white mb-2'}>العنوان</label>

                                        <Field
                                            id={"address"}
                                            name="address"
                                            type="text"
                                            style={{ boxSizing: 'border-box' }}
                                            onChange={(e: any) => {
                                                setChange(true);
                                                setFieldValue("address", e.target.value);
                                            }}
                                            className={'form-control  ' + style.inputstyle + (errors.address && touched.address ? ' is-invalid' : '')}
                                            placeholder={`ادخل عنوانك`}
                                        />
                                        <ErrorMessage name="address" className={style.TextError}
                                            component="div" />
                                    </div>

                                    <div className={'col-6 py-2'} style={{ boxSizing: 'border-box' }}>
                                        <label className={'text-white mb-2 labtex'}>النوع</label>
                                        <div>
                                            <label className={'text-white mx-3'}>
                                                <Field style={{ boxSizing: 'border-box' }} type="radio" className={'ms-2'} onChange={(e: any) => {
                                                    setChange(true);
                                                    setFieldValue("gender", e.target.value);
                                                }} name="gender" value="ذكر" />
                                                ذكر
                                            </label>
                                            <label className={'text-white mx-3'}>
                                                <Field style={{ boxSizing: 'border-box' }} className={'ms-2'} onChange={(e: any) => {
                                                    setChange(true);
                                                    setFieldValue("gender", e.target.value);
                                                }} type="radio" name="gender" value="انثي" />
                                                انثي
                                            </label>
                                        </div>


                                        <ErrorMessage name="gender" className={style.TextError}
                                            component="div" />
                                    </div>
                                    <div className={'col-6 py-2'} style={{ boxSizing: 'border-box' }}>
                                        <label className={'text-white mb-2 labtex'}>الإقامة في مدينة
                                            السادات</label>
                                        <div>
                                            <label className={'text-white mx-3'}>
                                                <Field style={{ boxSizing: 'border-box' }} type="radio" onChange={(e: any) => {
                                                    setChange(true);
                                                    setFieldValue("sadat", e.target.value);
                                                }} className={'ms-2'} name="sadat" value="1" />
                                                نعم
                                            </label>
                                            <label className={'text-white mx-3'}>
                                                <Field style={{ boxSizing: 'border-box' }} className={'ms-2'} onChange={(e: any) => {
                                                    setChange(true);
                                                    setFieldValue("sadat", e.target.value);
                                                }} type="radio" name="sadat" value="0" />

                                                لا
                                            </label>
                                        </div>


                                        <ErrorMessage name="sadat" className={style.TextError} component="div" />
                                    </div>
                                    <div className={'col-12 d-flex justify-content-center mt-4'} style={{ boxSizing: 'border-box' }}>
                                        <button type="submit" disabled={!Change} className="btn btn-success">حفظ
                                            التعديلات
                                        </button>
                                    </div>
                                </div>
                                <div
                                    onClick={() => setShow(true)}
                                    className={'col-12 d-flex justify-content-center mt-4'} style={{ boxSizing: 'border-box' }}>
                                    <button type="submit" disabled={!Change} className="btn btn-danger">
                                        حذف الحساب
                                    </button>
                                </div>
                            </Form>)}
                    </Formik>
                </div>
            </>)}


    </>)
}

export default AccountData;